export const Header = () => {
  return (
    <div className="flex w-full flex-row items-center justify-between px-10 py-5">
      <img
        src="/icon.png"
        alt="logo"
        className="w-14"
      />
      <h1 className="ml-4 text-lg font-700 text-black">お問い合わせ</h1>
    </div>
  );
};
